export default "__VITE_ASSET__BP9sfbyF__"